export const startChatBot = () => {
  return new Promise((resolve, reject) => {
    const startBotInTimer = setInterval(() => {
      if (window.NLPbot) {
        // if (window.userBot) {
        //   stopChatBot();
        // }
        var bot = new window.NLPbot();

        window.userBot = bot;

        clearInterval(startBotInTimer);

        resolve(bot);
      }
    }, 100);
  });
};

export const stopChatBot = (bot) => {
  try {
  console.log("stopChatbot");
  window.serverUrl = ""; // Server URL
  window.apiUrl = ""; // Server URL
  window.url_extension = "";
  window.api_extension = "";
  window.train_publish = "";
  // window.user_type =
  window.bot_id = 0;
  window.account_id = 0;
  // return null;
  window.user_id = 0;
  window.user_type = 0;
  window.paramsObject = null;
  window.userBot.destroy();
  }
  catch(err) {
    console.log(err)
  }
};

export const initBot = (botSettings, botParams) => {
  return new Promise(function (resolve, reject) {
    window
      .loadBot(
        document,
        "script",
        "nlpbot" + botSettings.botId + "main",
        botSettings,
        botParams
      )
      .then(resolve)
      .catch((err) => console.log(err));
  });
};

// New streaming chatbot function
export const streamChatbotMessage = async (
  message,
  threadId,
  courseContext,
  userDetails,
  onChunk,
  onComplete,
  onError,
  options = {} // { signal?: AbortSignal }
) => {
  const controller = options.signal ? null : new AbortController();
  const signal = options.signal || controller?.signal;

  try {
    const auth = localStorage.getItem('auth');
    if (!auth) throw new Error('Authentication token not found. Please log in again.');

    const response = await fetch('/api/v0.2/chatbot/stream_message', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': auth
      },
      body: JSON.stringify({ message, threadId, courseContext, userDetails }),
      signal
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    if (!response.body) throw new Error('ReadableStream not supported');

    
   // ⬇️ SSE reader loop (drop-in replacement)
const reader = response.body.getReader();
const decoder = new TextDecoder();
let buf = "", full = "";

outer: while (true) {
  const { value, done } = await reader.read();
  if (done) break;

  buf += decoder.decode(value, { stream: true });
  const frames = buf.split("\n\n");
  buf = frames.pop() || "";

  for (const frame of frames) {
    // ignore comments/keep-alives (lines starting with ":")
    const dataLine = frame.split("\n").find(l => l.startsWith("data:"));
    if (!dataLine) continue;

    const data = dataLine.replace(/^data:\s?/, "").trim();
    if (!data) continue;

    if (data === "[DONE]") {
      try { await reader.cancel(); } catch {}
      break outer;
    }

    let json;
    try { json = JSON.parse(data); } catch { continue; }

    // Expect either: delta (token), or snapshot (cumulative full-so-far)
    const incoming = typeof json.text === "string" ? json.text : "";
    const isDelta = json.type === "delta";
    const isSnapshot = json.type === "snapshot";

    if (isDelta) {
      // Pure token from server – append and emit
      if (incoming) {
        full += incoming;
        onChunk?.(incoming, full, json);
      }
    } else if (isSnapshot) {
      // Snapshot: resync to full and emit unseen tail if any, else force repaint
      if (incoming) {
        const previous = full;
        let delta = "";
        if (incoming.length > full.length && incoming.startsWith(full)) {
          delta = incoming.slice(full.length);
        }
        full = incoming;
        if (delta) onChunk?.(delta, full, json);
        else if (previous !== full) onChunk?.("", full, json);
      }
    } else {
      // Unknown frame types: ignore safely
    }
  }
}

onComplete?.(full);

    return full;
  } catch (error) {
    console.error('Streaming chatbot error:', error);
    onError?.(error);
    throw error;
  }
};

